import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { productsDefault } from 'Components/User/Purchases/Products'
import { apiPurchasesList, apiPurchasesView } from 'Services/UserService'

export const getData = createAsyncThunk('user/purchases/getData', async datas => {
    const { data } = await apiPurchasesList(datas)
    return data
})

export const getView = createAsyncThunk('user/purchases/getView', async id => {
    if (!id) return viewData
    const { data } = await apiPurchasesView(id)
    data.images = []
    data.image_remove = []
    data.products = data.products && data.products.length !== 0 ? data.products : [productsDefault]
    return data
})

const viewData = {
    vendor_id: '',
    vendor_number: '',
    invoice_date: '',
    details: '',
    sub_total: '',
    gst: 9,
    cgst_amount: '',
    sgst_amount: '',
    discount: 0,
    total: '',
    products: [productsDefault],
}

export const purchasesSlice = createSlice({
    name: 'user/purchases',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            store_id: '',
            vendor_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStoreId: (state, { payload }) => {
            state.table.page = 1
            state.table.store_id = payload
            state.table.vendor_id = ''
        },
        setVendorId: (state, { payload }) => {
            state.table.page = 1
            state.table.vendor_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setStoreId, setVendorId } = purchasesSlice.actions

export default purchasesSlice.reducer
